// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ng","bodyOpen":"og","content":"pg","header":"qg","close":"rg","closeNoHeading":"sg"};